import React from 'react'

interface ErrorsSectionProps {
  missingValuesCount: number
  duplicatesCount: number
  formatIssuesCount: number
  rangeViolationsCount: number
  conflictsCount: number
  schemaDriftChanges: number
}

const ErrorsSection: React.FC<ErrorsSectionProps> = ({
  missingValuesCount,
  duplicatesCount,
  formatIssuesCount,
  rangeViolationsCount,
  conflictsCount,
  schemaDriftChanges
}) => {
  return (
    <div className="file-errors-section">
      <h3 className="section-title">Errors and Warnings</h3>
      <div className="error-breakdown-items">
        <div className="error-item">
          <span className="error-label">Missing Values:</span>
          <span className="error-value">{missingValuesCount}</span>
        </div>
        <div className="error-item">
          <span className="error-label">Duplicates:</span>
          <span className="error-value">{duplicatesCount}</span>
        </div>
        <div className="error-item">
          <span className="error-label">Format Issues:</span>
          <span className="error-value">{formatIssuesCount}</span>
        </div>
        <div className="error-item">
          <span className="error-label">Range Violations:</span>
          <span className="error-value">{rangeViolationsCount}</span>
        </div>
        <div className="error-item">
          <span className="error-label">Conflicts:</span>
          <span className="error-value">{conflictsCount}</span>
        </div>
        <div className="error-item">
          <span className="error-label">Schema Drift:</span>
          <span className="error-value">{schemaDriftChanges}</span>
        </div>
      </div>
    </div>
  )
}

export default ErrorsSection
